<ngx-spinner 
    name="index-spinner"
    bdColor="rgba(51,51,51,0.8)"
    size="medium"
    color="#fff"
    type="ball-clip-rotate"
>
    <p aria-live="polite" style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>

<div *ngIf="displayBanner" id="browseBacklink" class="col-xs-12">
    <a routerLink="/thesauri" queryParamsHandling="preserve">
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" fill="currentColor" class="bi bi-chevron-left" viewBox="0 0 18 18">
            <path stroke="white" fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"/>
        </svg>
        <span>{{'selectAnother' | i18next}}</span>
    </a>
</div>

<ng-container *ngIf="isServiceError() && isServiceErrorSource(); then errorContainer else termsContainer"></ng-container>

<ng-template #termsContainer>
    <div id="browseTermsContainer" *ngIf="thesaurus">
        <div class="thesaurus-title row">
            <div [ngClass]="{'col-12': !isLexiconThesaurus(), 'col-7': 'isLexiconThesaurus()'}" class="popover-container">
                <h1>{{thesaurus.name}}</h1>
                <span *ngIf="isLexiconThesaurus() || isCorporationThesaurus()">
                    <app-popover [thesaurusId]="this.thesaurus.id"></app-popover>
                </span>
            </div>
            <div *ngIf="isLexiconThesaurus()" class="col-5 mb-3">
                <app-header-logo></app-header-logo>               
            </div>
        </div>

        <form #searchForm="ngForm">
            <div class="searchTermsContainer">
                <div class="row g-4">
                    <div class="col-3">
                        <label *ngIf="!isCorporationThesaurus()" class="search-terms-label" for="searchTerm">{{'label_title_search' | i18next}}</label>
                        <label *ngIf="isCorporationThesaurus()" class="search-terms-label" for="searchTerm">{{'company_label_title' | i18next}}</label>
                    </div>

                    <div class="col-7">
                        <input type="text" id="searchTerm" name="searchTerm" [(ngModel)]="searchTerm">

                        <div class="search-radio-btn-wrapper">
                            <label class="switch contains-btn-label">
                                <input type="radio" class="contains" value="contains" name="searchOption" (change)="onOptionChange('contains')" [(ngModel)]="searchOption">
                                <span>{{'label_contains.text' | i18next}}</span>
                            </label>
                            <label class="switch begins-btn-label">
                                <input type="radio" class="begins" value="begins" name="searchOption" (change)="onOptionChange('begins')" [(ngModel)]="searchOption">
                                <span>{{'label_begins.text' | i18next}}&nbsp;</span>
                                <span class="small">{{'label_begins_chars' | i18next}}</span>
                            </label>
                        </div>
                    </div>

                    <div class="col-1 find">
                        <button class="btn btn-pq-brand" type="submit" (click)="findSearchTerm($event, this.thesaurus.id, searchTerm, this.searchOption, this.searchCategory, this.searchType)">{{'button_find' | i18next}}</button>
                    </div>
                    <div class="col-1 clearLink">
                        <a href=# role="button" (click)="onClearSearchTermsClick($event)">{{'resetLink' | i18next}}</a>
                    </div>
                </div>
            </div>
        </form>

        <div id="lexiconDropdown" *ngIf="isLexiconThesaurus()">
            <app-select-dropdown
                [dropdownLabel]="getDropdownLabel('acta_lexicon_qualifiers_searchcategoryselect_label')"
                [options]="lexiconOptions"
                [ariaLabelSelect]="ariaLabelLexicon"
                [searchCategory]="searchCategory"
                (searchCategoryChange)="onSearchCategoryChange($event)">
            </app-select-dropdown>
        </div>

        <!--FOR PQ-93633: INSERT CATEGORY DROPDOWN FOR CORPORATION-->
        <div id="corporationDropdown" *ngIf="isCorporationThesaurus()">
            <app-select-dropdown
                [dropdownLabel]="getDropdownLabel('company_searchtypeselect_label')"
                [options]="corporateSearchTypes"
                [ariaLabelSelect]="ariaLabelCorporate"
                [searchCategory]="searchType"
                (searchCategoryChange)="onSearchTypeChange($event)">
            </app-select-dropdown>
        </div>

        <div id="skipPage">
            <a shape="rect" accesskey="8" href="#" (click)="onSkipAToZ($event)" (keydown.enter)="onSkipAToZ($event)">{{'skipPag' | i18next}}</a>
            <span class="hidden-skip-text">{{'skipPag' | i18next}}</span>
        </div>

        <div class="row align-items-start" *ngIf="availableThesaurusTerms">
            <div *ngIf="!isCorporationThesaurus()" class="col-3 strong">{{'browseSubjectsLabel' | i18next}}</div>
            <div *ngIf="isCorporationThesaurus()" class="col-3 strong">{{'company_browseSubjectsLabel' | i18next}}</div>
            <div class="col-9">
                <ul id="browseTermsList" class="list-group list-group-horizontal">
                    <li *ngIf="!thesaurus.browseRoot">
                        <a href="#" (click)="onBrowseTermsClick($event, this.thesaurus.id, 'All');"id="browseTerms-All">{{allEntries}}</a>
                    </li>
                    <li *ngIf="thesaurus.browseRoot">
                        <a href="#" (click)="onBrowseTermsClick($event, this.thesaurus.id, 'Root');" id="browseTerms-Root">{{rootEntry}}</a>
                    </li>
                    <li *ngFor="let availableTerm of this.termsCollection; let i = index">
                        <span *ngIf="this.termsCollection[i].displayUrl">
                            <a href="#" (click)="onBrowseTermsClick($event, this.thesaurus.id, this.termsCollection[i].facet);" id="browseTerms-{{i}}">
                                {{this.termsCollection[i].display}}
                           </a>
                        </span>
                        <span *ngIf="!this.termsCollection[i].displayUrl" class="disabled-term-wrapper">
                            <a href="#" class="disabled">
                                {{this.termsCollection[i].display}}
                            </a>
                        </span>

                    </li>
                </ul>
            </div>
        </div>
        
        <!--FOR PQ-93632: INSERT CATEGORY PILLS FOR BUSINESS SUBJECT-->
        <div id="businessCategoryPills" *ngIf="availableThesaurusCategories && availableThesaurusCategories.availableCategories && availableThesaurusCategories.availableCategories.length > 0" >
            <div class="col-3 strong">{{'browseCategoriesLabel' | i18next}}</div>
            <div class="BSsourceBtns">
                <div class="BSsourceBtnsInner">
                        <ul id="thesaurus-pills-wrapper" class="category-list">
                            <li *ngFor="let availableCategory of this.availableThesaurusCategories.availableCategories; let i = index" class="category-list-item">
                                <a href="#" (click)="onBrowseCategoriesClick($event, this.thesaurus.id, availableCategory.category);" id="browseCategories-{{i}}" class="category-link">
                                    {{availableCategory.displayName}}
                                </a>
                            </li>
                        </ul>
                </div>
            </div>
        </div>

    </div>
</ng-template>

<ng-template #errorContainer>
    <app-service-error id="errorMsg-Terms"></app-service-error>
</ng-template>
